import { notify } from 'utils/reduxUtils';

export const types = {
  OPEN_REQUEST: 'common/modals/workflowStatusOverviewModal/OPEN_REQUEST',
  OPEN_ERROR: 'common/modals/workflowStatusOverviewModal/OPEN_ERROR',
  OPEN_SUCCESS: 'common/modals/workflowStatusOverviewModal/OPEN_SUCCESS',
  CLOSE: 'common/modals/workflowStatusOverviewModal/CLOSE',
  QUOTE_ITEM_CLICKED:
    'common/modals/workflowStatusOverviewModal/QUOTE_ITEM_CLICKED',
  RECEIVE_QUOTE_WORKFLOW:
    'common/modals/workflowStatusOverviewModal/RECEIVE_QUOTE_WORKFLOW',
};

export const open = {
  error: notify(
    (error) => ({
      type: types.OPEN_ERROR,
      payload: { error },
    }),
    'Error while opening workflow status overview',
  ),
  request: ({ quoteId, callback }) => ({
    type: types.OPEN_REQUEST,
    payload: { quoteId, callback },
  }),
  success: () => ({
    type: types.OPEN_SUCCESS,
  }),
};

export const workflowStatusOverviewModal = {
  close: () => ({
    type: types.CLOSE,
  }),
};

export const quoteItemClicked = ({ quoteItemId }) => ({
  type: types.QUOTE_ITEM_CLICKED,
  payload: { quoteItemId },
});

export const receiveQuoteWorkflow = ({ quoteWorkflow }) => ({
  type: types.RECEIVE_QUOTE_WORKFLOW,
  payload: { quoteWorkflow },
});
